import andrewImg from '@/static/assets/customer_reviews/pics/tweet_face_andrew.png';
import awakingImg from '@/static/assets/customer_reviews/pics/tweet_face_awaking.png';
import brentImg from '@/static/assets/customer_reviews/pics/tweet_face_brent.png';
import jackyImg from '@/static/assets/customer_reviews/pics/tweet_face_jacky.png';
import mariaImg from '@/static/assets/customer_reviews/pics/tweet_face_maria.png';
import rashiqImg from '@/static/assets/customer_reviews/pics/tweet_face_rashiq.png';
import rohanImg from '@/static/assets/customer_reviews/pics/tweet_face_rohan.png';
import stephenImg from '@/static/assets/customer_reviews/pics/tweet_face_stephen.png';
import valeriaImg from '@/static/assets/customer_reviews/pics/tweet_face_valeria.png';

export const tweets = [
  {
    name: 'Brent',
    img: brentImg,
    handle: 'goforbrent',
    text: '<span class="primary">@Lemonade_Inc</span> was the simplest and easiest insurance I’ve ever purchased, “old” insurance companies need to step into the current century!!! 👏 👏 👏',
  },
  {
    name: 'Valeria Delgado',
    handle: 'Valeriad90',
    img: valeriaImg,
    text: 'Why doesn’t everyone use <span class="primary">@Lemonade_Inc</span> insurance? I just switched and slashed my costs by $110 <span class="primary">#Winning</span>',
  },
  {
    name: 'Stephen Huber',
    handle: 'stephen_huber',
    img: stephenImg,
    text: 'Wow. Just filed a claim with <span class="primary">@Lemonade_Inc</span> and got paid in literally 7 seconds. If you rent or own a home, you NEED to get this insurance. <span class="primary">#insurance #lemonade #NotAnAd</span>',
  },
  {
    name: 'Maria Salamanka',
    handle: 'MariaSalamankaM',
    img: mariaImg,
    text: 'Always disappointed in how much insurance will fight against customer in a claim. Just had my first good experience with filing. Unbelievably quick and solid customer experience with <span class="primary">@Lemonade_Inc</span>.',
  },
  {
    name: 'Rohan Gandhi',
    handle: 'timesnewrohan',
    img: rohanImg,
    text: '<span class="primary">@Lemonade_Inc</span> I just bought home insurance from you and I’m pretty sure it was easier than ordering pizza. Awesome job on the experience.',
  },
  {
    name: 'AWaking Dream',
    handle: 'AWaking_Dream',
    img: awakingImg,
    text: 'Once every 2-3 years, I stumble across a truly outstanding app / business which nails everything. UX, pricing, customer service - <span class="primary">@Lemonade_Inc</span> has it all and I love it: <span class="primary">www.lemonade.com</span>',
  },
  {
    name: 'Rashiq in SF',
    handle: 'rashiq',
    img: rashiqImg,
    text: '<span class="primary">@Lemonade_Inc</span> wow this was hands down the best insurance experience ever. holy shit I love your app.',
  },
  {
    name: 'jacky',
    handle: 'jjackyliang',
    img: jackyImg,
    text: '<span class="primary">@Lemonade_Inc</span> Truly lovely onboarding + customer support for a normally super frustrating service.',
  },
  {
    name: 'Andrew Horn',
    handle: 'itsandrewhorn',
    img: andrewImg,
    text: 'WOW - what an amazing company. Check out <span class="primary">@Lemonade_Inc</span> if you need homeowner or rental insurance. Have been loving the process so far.',
  },
];
